import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';

// ポイント獲得者のbet_idを格納
export const earnedPointShowFlagsState = atom<number[]>({
  key: ATOM_KEYS.EARNED_POINT_SHOW_FLAGS_STATE,
  default: [],
});
